<template>
  <v-row>
    <v-col :cols="12" style="margin-top: -30px">
      <material-card
        color="green"
        title="Personal Info"
        dense
      >
        <v-form>
          <v-text-field
            v-model="activeAccount.account.created"
            label="Created"
            placeholder="YYYY-MM-DD HH:mm:ss"
            prepend-icon="event"
            data-vv-name="created"
            readonly
          />
          <v-text-field
            v-if="activeAccount.account.avatar"
            v-model="activeAccount.account.avatar"
            label="Avatar Name"
            prepend-icon="mdi-account-box-outline"
            data-vv-name="avatar"
            readonly
          />
          <v-text-field
            v-model="activeAccount.account.profile.name"
            label="Name"
            data-vv-name="name"
            :readonly="$store.state.auth.checkAccess({key: 'profile_edit_deny', value: true})"
            :disabled="$store.state.auth.checkAccess({key: 'hide_profile', value: true})"
            required
          >
            <template v-slot:append-outer>
              <default-history
                class="d-inline-block"
                type="profile.name"
                handler="default"
                icon="history"
                size="small"
                icon-size="19px"
                title="Profile History"
              />
            </template>
          </v-text-field>
          <v-text-field
            v-model="activeAccount.account.profile.surname"
            label="Surname"
            data-vv-name="surname"
            :readonly="$store.state.auth.checkAccess({key: 'profile_edit_deny', value: true})"
            :disabled="$store.state.auth.checkAccess({key: 'hide_profile', value: true})"
            required
          >
            <template v-slot:append-outer>

              <default-history
                class="d-inline-block"
                type="profile.surname"
                handler="default"
                icon="history"
                size="small"
                icon-size="19px"
                title="Profile History"
              />
            </template>
          </v-text-field>
          <v-text-field
            v-model="activeAccount.account.profile.birthday"
            label="Birthday date"
            placeholder="YYYY-MM-DD"
            prepend-icon="event"
            data-vv-name="birthday"
            :readonly="$store.state.auth.checkAccess({key: 'profile_edit_deny', value: true})"
            :disabled="$store.state.auth.checkAccess({key: 'hide_profile', value: true})"
            v-mask="`####-##-##`"
          >
            <template v-slot:append>
              <b class="years-append">{{ calculateAgeFromDate(activeAccount.account.profile.birthday) }} Years</b>
            </template>
            <template v-slot:append-outer>
              <default-history
                class="d-inline-block"
                type="profile.birthday"
                handler="default"
                icon="history"
                size="small"
                icon-size="19px"
                title="Profile History"
              />
            </template>
          </v-text-field>
          <v-select
            label="Gender"
            placeholder="Male/Female"
            v-model="activeAccount.account.profile.gender"
            data-vv-name="gender"
            :readonly="$store.state.auth.checkAccess({key: 'profile_edit_deny', value: true})"
            :disabled="$store.state.auth.checkAccess({key: 'hide_profile', value: true})"
            :items="genderList">
            <template v-slot:append-outer>
              <default-history
                class="d-inline-block"
                type="profile.gender"
                handler="default"
                icon="history"
                size="small"
                icon-size="19px"
                title="Profile History"
              />
            </template>
          </v-select>
          <v-text-field
            v-model="activeAccount.account.language"
            label="Language"
            placeholder="EN/RU/PL etc"
            append-icon="flag"
            data-vv-name="language"
            v-mask="`AA-AA`"
            :readonly="$store.state.auth.checkAccess({key: 'profile_edit_deny', value: true})"
            :disabled="$store.state.auth.checkAccess({key: 'hide_profile', value: true})"
          >
            <template v-slot:append-outer>
              <default-history
                class="d-inline-block"
                type="language"
                handler="default"
                icon="history"
                size="small"
                icon-size="19px"
                title="Profile History"
              />
            </template>
          </v-text-field>
          <v-select
            label="Country"
            v-model="activeAccount.account.country"
            data-vv-name="country"
            append-icon="flag"
            item-value="code"
            item-text="title"
            :readonly="$store.state.auth.checkAccess({key: 'profile_edit_deny', value: true})"
            :disabled="$store.state.auth.checkAccess({key: 'hide_profile', value: true})"
            :items="$store.state.app.countries">

            <template v-slot:append-outer>
              <default-history
                class="d-inline-block"
                type="country"
                handler="default"
                icon="history"
                size="small"
                icon-size="19px"
                title="Profile History"
              />
            </template>
          </v-select>
          <v-text-field
            v-model="activeAccount.account.profile.city"
            label="City"
            placeholder="Moscow/London/Berlin etc"
            data-vv-name="city"
            :readonly="$store.state.auth.checkAccess({key: 'profile_edit_deny', value: true})"
            :disabled="$store.state.auth.checkAccess({key: 'hide_profile', value: true})"
          >
            <template v-slot:append-outer>
              <default-history
                class="d-inline-block"
                type="profile.city"
                handler="default"
                icon="history"
                size="small"
                icon-size="19px"
                title="Profile History"
              />
            </template>
          </v-text-field>
          <v-text-field
            v-model="activeAccount.account.profile.address"
            label="Address Line"
            placeholder="Snowy Rock Pl"
            data-vv-name="address"
            :readonly="$store.state.auth.checkAccess({key: 'profile_edit_deny', value: true})"
            :disabled="$store.state.auth.checkAccess({key: 'hide_profile', value: true})"
          >
            <template v-slot:append-outer>
              <default-history
                class="d-inline-block"
                type="profile.address"
                handler="default"
                icon="history"
                size="small"
                icon-size="19px"
                title="Profile History"
              />
            </template>
          </v-text-field>
          <v-text-field
            v-model="activeAccount.account.profile.postcode"
            label="Post Code"
            placeholder="BG1000"
            data-vv-name="postcode"
            :readonly="$store.state.auth.checkAccess({key: 'profile_edit_deny', value: true})"
            :disabled="$store.state.auth.checkAccess({key: 'hide_profile', value: true})"
          >
            <template v-slot:append-outer>
              <default-history
                class="d-inline-block"
                type="profile.postcode"
                handler="default"
                icon="history"
                size="small"
                icon-size="19px"
                title="Profile History"
              />
            </template>
          </v-text-field>

          <v-text-field
            v-if="activeAccount.account.profile.cpf || activeAccount.account.country == 'BR'"
            v-model="activeAccount.account.profile.cpf"
            label="CPF"
            data-vv-name="cpf"
            :readonly="$store.state.auth.checkAccess({key: 'profile_edit_deny', value: true})"
            :disabled="$store.state.auth.checkAccess({key: 'hide_profile', value: true})"
          >
            <template v-slot:append-outer>
              <default-history
                class="d-inline-block"
                type="profile.cpf"
                handler="default"
                icon="history"
                size="small"
                icon-size="19px"
                title="Profile History"
              />
            </template>
          </v-text-field>

          <v-text-field
            v-if="activeAccount.account.profile.personal_id"
            v-model="activeAccount.account.profile.personal_id"
            label="Personal ID"
            data-vv-name="personal_id"
            :readonly="$store.state.auth.checkAccess({key: 'profile_edit_deny', value: true})"
            :disabled="$store.state.auth.checkAccess({key: 'hide_profile', value: true})"
          >
            <template v-slot:append-outer>
              <default-history
                class="d-inline-block"
                type="profile.personal_id"
                handler="default"
                icon="history"
                size="small"
                icon-size="19px"
                title="Profile History"
              />
            </template>
          </v-text-field>

          <v-row class="mx-0">
            <v-text-field
              v-model="activeAccount.account.phone"
              :readonly="!$store.state.auth.checkAccess({key: 'phone', value: true}) || $store.state.auth.checkAccess({key: 'profile_edit_deny', value: true})"
              :disabled="$store.state.auth.checkAccess({key: 'hide_profile', value: true})"
              label="Phone"
              data-vv-name="phone"
            >
              <template v-slot:append-outer>

                <default-history
                  class="d-inline-block"
                  type="phone"
                  handler="default"
                  icon="history"
                  size="small"
                  icon-size="19px"
                  title="Profile History"
                />
              </template>
            </v-text-field>

            <v-checkbox
              label="Verified"
              v-model="activeAccount.account.is_verified.phone"
              :disabled="$store.state.auth.checkAccess({key: 'hide_profile', value: true})"
              hide-details
              class="ml-5"
            ></v-checkbox>
          </v-row>

          <v-row class="mx-0">
            <v-text-field
              v-model="activeAccount.account.email"
              :disabled="$store.state.auth.checkAccess({key: 'hide_profile', value: true})"
              :append-icon="activeAccount.account.is_verified.email_auto ? 'mdi-check-bold' : 'mdi-close-thick'"
              label="Email"
              class="email-validation-color"
              data-vv-name="email"
            >
              <template v-slot:append-outer>

                <default-history
                  class="d-inline-block"
                  type="email"
                  handler="default"
                  icon="history"
                  size="small"
                  icon-size="19px"
                  title="Profile History"
                />
              </template>
            </v-text-field>

            <v-checkbox
              label="Verified"
              v-model="activeAccount.account.is_verified.email"
              :disabled="$store.state.auth.checkAccess({key: 'hide_profile', value: true})"
              hide-details
              class="ml-5"
            />
          </v-row>
          <v-text-field
            v-model="activeAccount.account.last_login"
            label="Last Login"
            placeholder="YYYY-MM-DD HH:mm:ss"
            prepend-icon="event"
            data-vv-name="last_login"
            readonly
          />
          <v-text-field
            v-model="activeAccount.account.ip"
            label="IP"
            data-vv-name="ip"
            readonly
          />
          <v-btn
            v-if="!$store.state.auth.checkAccess({key: 'profile_edit_deny', value: true}) && !$store.state.auth.checkAccess({key: 'hide_profile', value: true})"
            class="mr-4"
            color="primary"
            :loading="activeAccount.loading"
            :disabled="activeAccount.loading"
            @click="saveAccount()"
          >save
          </v-btn>
        </v-form>
      </material-card>

      <material-card color="green" title="Security">
        <v-btn
          class="mb-5"
          color="info"
          block
          @click="disable2FA()"
          :disabled="!$store.state.auth.checkAccess({ key: 'change_password', value: true }) || !activeAccount.account.twofa"
        >
          Disable 2FA
        </v-btn>
        <v-dialog v-model="password.modal" max-width="290">
          <template v-slot:activator="{ on }">
            <v-btn class="mb-5" v-on="on" color="info" block :disabled="!$store.state.auth.checkAccess({ key: 'change_password', value: true })">Change Password</v-btn>
          </template>
          <v-card v-if="password.modal">
            <v-card-title class="headline">Change Password</v-card-title>
            <v-card-text>
              <v-text-field label="New Password" v-model="password.new" />
            </v-card-text>
            <v-card-actions>
              <v-btn color="warning" outlined @click="password.modal = false">Cancel</v-btn>
              <v-spacer></v-spacer>
              <v-btn color="primary" outlined light @click="passwordChange()">Save</v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
        <login-history></login-history>
      </material-card>
    </v-col>
  </v-row>
</template>

<style>
  .custom_label > label div {
    vertical-align: super;
    display: inline-block;
    cursor: pointer;
    user-select: none;
    line-height: 24px;
  }

  .email-validation-color .mdi-close-thick {
    color: red
  }

  .email-validation-color .mdi-check-bold {
    color: green
  }

  .years-append {
    color: gray;
    font-size: 13px;
    margin-top: 7px;
  }
</style>

<script>
  import _, { get } from 'lodash'
  import { mask } from 'vue-the-mask'
  import { API } from '@/utils/api'
  import { calculateAgeFromDate, findParentComponentByTag } from '@/utils/helper'
  import { mapGetters } from 'vuex'

  const fields = [
    'profile.name',
    'profile.surname',
    'profile.birthday',
    'profile.gender',
    'profile.cpf',
    'language',
    'country',
    'profile.city',
    'profile.address',
    'profile.postcode',
    'phone',
    'email',
    'is_verified.email',
    'is_verified.phone',
  ]

  export default {
    directives: {
      mask,
    },
    props: [],

    components: {
      LoginHistory: () => import('@/components/helper/LoginHistory'),
      DefaultHistory: () => import('@/components/helper/DefaultHistory'),
    },

    data: () => ({
      password: {
        modal: false,
        new: ''
      },
      typeList: [
        'casino', 'sport', 'test', 'affiliate'
      ],
      levelMap: {
        1: 'Bronze',
        2: 'Silver',
        3: 'Gold'
      },
      genderList: [ { text: 'Male', value: 'M' }, { text: 'Female', value: 'F' } ],

      loading: false
    }),

    computed: {

      ...mapGetters({ activeAccount: 'account/active' }),
      accountLevel: function () {
        return this.levelMap[this.activeAccount.account.level] || this.activeAccount.levelMap[1]
      }
    },

    mounted () {
      this.mainView = findParentComponentByTag(this, 'user-main-view')
    },

    methods: {
      calculateAgeFromDate,
      passwordChange () {
        if (this.$store.state.auth.checkAccess({ key: 'change_password', value: true })) {
          API.call('/$v/account/change_password.json', {
            login: this.activeAccount.account.login,
            account_id: this.activeAccount.account.account_id,
            password: this.password.new
          }, this.activeAccount.account).then(resp => {
            this.$notification.show = true
            this.$notification.message = 'Password updated'
            this.$notification.type = 'success'

            this.password.new = ''
            this.password.modal = false
          }).catch(e => {
            return e
          }).finally(() => {

          })
        }
      },
      async disable2FA () {
        if (!await this.$root.$confirm('Confirm', 'Disable 2FA')) {
          return
        }

        if (this.$store.state.auth.checkAccess({ key: 'change_password', value: true })) {
          API.call('/$v/account/disable2fa.json', {
            login: this.activeAccount.account.login,
            account_id: this.activeAccount.account.account_id,
          }, this.activeAccount.account).then(resp => {
            _.set(this.activeAccount.account, 'twofa', false)
            _.set(this.activeAccount.initAccount, 'twofa', false)
            this.$notification.show = true
            this.$notification.message = '2FA was disabled'
            this.$notification.type = 'success'
          }).catch(e => {
            return e
          }).finally(() => {

          })
        }
      },
      saveAccount () {
        this.activeAccount.loading = true

        let params = {}
        let initParams = {}

        for (let k of fields) {
          if (_.get(this.activeAccount.account, k) != _.get(this.activeAccount.initAccount, k)) {
            params[k] = _.get(this.activeAccount.account, k)
            initParams[k] = _.get(this.activeAccount.initAccount, k)
          }
        }

        API.call('/$v/account/update.json', {
          login: this.activeAccount.account.login,
          account_id: this.activeAccount.account.account_id,
          fields: params,
          init_fields: initParams,
        }, this.activeAccount.account).then(resp => {

          for (let k of fields) {
            if (_.get(this.activeAccount.account, k) != _.get(this.activeAccount.initAccount, k)) {
              _.set(this.activeAccount.initAccount, k, _.get(this.activeAccount.account, k))
            }
          }

          return resp.data
        }).then(r => {
          this.$notification.show = true
          this.$notification.message = 'Profile updated'
          this.$notification.type = 'success'
        }).catch(e => {
          return e
        }).finally(() => {
          this.activeAccount.loading = false
        })
      }
    },

  }
</script>
